import AppSnackbar from 'module/snackbar/AppSnackbar.vue'; // Animation is 2200ms, directed by global styles.

import {
    createVNode, render,
} from 'vue';

const SNACKBAR_LIFETIME = 3000;

const mountComponent = (component, { props, children, element } = {}) => {
    let el = element;

    let vNode = createVNode(component, props, children);
    if (el) render(vNode, el);
    else if (typeof document !== 'undefined') render(vNode, el = document.createElement('div'));

    const destroy = () => {
        if (el) render(null, el);
        el.remove();
        el = null;
        vNode = null;
    };

    return { vNode, destroy, el };
};

export async function showSnackbar(props = {}) {
    const { el, destroy } = mountComponent(
        AppSnackbar,
        {
            props: {
                ...props,
                /*
                displayed: Boolean,
                animationDuration: String,
                icon: Boolean,
                text: String,
                link: String,
                linkText: String,
                linkEvent: String,
                actionLink: Boolean,
                value: [Boolean, Number, String],
                dislikeId: [Boolean, Number, String],
                company: [Boolean, Number, String],
                 */
            },
        },
    );

    document.body.appendChild(el);

    return new Promise((resolve) => {
        setTimeout(() => {
            destroy();
            resolve();
        }, SNACKBAR_LIFETIME);
    });
}
